interface ICurateUnitCo2EmissionsByVenueTypeAPI {
  mediatype_id: number;
  mediatype_name: string;
  mediatype_code: string;
  total_gco2e: number;
}

export default class CurateUnitCo2eEmissionsByVenueType {
  mediaTypeId: number;
  mediaTypeName: string;
  mediaTypeCode: string;
  totalGco2e: number;

  constructor(mediaTypeId: number, mediaTypeName: string, mediaTypeCode: string, totalGco2e: number) {
    this.mediaTypeId = mediaTypeId;
    this.mediaTypeName = mediaTypeName;
    this.mediaTypeCode = mediaTypeCode;
    this.totalGco2e = totalGco2e;
  }

  static fromApi(apiObject: ICurateUnitCo2EmissionsByVenueTypeAPI): CurateUnitCo2eEmissionsByVenueType {
    return new CurateUnitCo2eEmissionsByVenueType(
      apiObject.mediatype_id,
      apiObject.mediatype_name,
      apiObject.mediatype_code,
      apiObject.total_gco2e,
    );
  }
}
